// MainPage.js — responsive marketplace layout
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sort from "./Sort";
import ProductList from "./ProductList";
import FilterSection from "./FilterSection";

const MainPage = () => {
  return (
    <Container className="marketplace-page">
      <Row className="g-3 g-lg-4">
        {/* Filters stack above products on tablet/phone */}
        <Col xs={12} lg={3}>
          <FilterSection />
        </Col>
        <Col xs={12} lg={9}>
          <Row>
            <Sort />
          </Row>
          <Row>
            <ProductList />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default MainPage;
